import { Box, Modal, Text } from '@mantine/core';
import { useRef, useState, useEffect } from 'react';
import { useStyles } from './style';
import close from '../../../assets/icons/close.svg';
import { properties } from '../properties';
import { MdDeleteOutline } from 'react-icons/md';
import { baseURL } from '../../../config/urls';
import { getHeader, doRedirectIfUnAuth } from '../../../config/userSession';
const Notifications = ({ opened, onClose }) => {
  const { classes, theme } = useStyles(useStyles);
  const [notifications, setNotifications] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [entries, setEntries] = useState([]);
  const [pageLoadEntries, setPageLoadEntries] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [notificationIds, setNotificationIds] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const cacheListing = useRef({});
  const params = new URLSearchParams();
  params.append('page', activePage);
  params.append('pSize', pageSize);

  useEffect(() => {
    if (opened) {
      const ids = notifications.map((n) => n.id);
      setNotificationIds(ids);
    }
  }, [notifications, opened]);

  const updateNotifications = async () => {
    const response = await fetch(`${baseURL}/account/notifications`, {
      method: 'PUT',
      headers: getHeader(),
      body: JSON.stringify({ ids: notificationIds })
    });
    if (response.ok) {
      await response.json();
    }
  };
  useEffect(() => {
    if (!opened && notifications.length > 0) {
      updateNotifications();
    }
  }, [notifications, opened]);
  const fetchInvitations = async () => {
    if (params in cacheListing) {
      setEntries(cacheListing[params]);
      return;
    }

    const response = await fetch(
      `${baseURL}/account/notifications?` + params.toString(),
      {
        method: 'GET',
        headers: getHeader()
      }
    );
    if (response.ok) {
      const invitationList = await response.json();
      console.log(invitationList);
      setNotifications(invitationList.data);
      setPageLoadEntries(invitationList.data);
      setTotalPage(Math.ceil(invitationList.totalCount / pageSize));
      cacheListing[params] = invitationList.data;
    } else {
      doRedirectIfUnAuth(response.status);
    }
  };

  useEffect(() => {
    if (opened) {
      fetchInvitations();
    }
  }, [opened]);
  return (
    <Modal
      transitionProps={{
        transition: 'slide-left',
        duration: 500
      }}
      withCloseButton={false}
      yOffset={100}
      xOffset={0}
      className={classes.notificationsContainer}
      opened={opened}
      onClose={() => onClose()}
    >
      <Box className={classes.header}>
        <p className={classes.title}>Notifications</p>
        <img
          src={close}
          onClick={() => onClose()}
          alt="close"
          className={classes.closeIcon}
        />
      </Box>

      <Box className={classes.notifications}>
        {notifications?.length > 0 ? (
          notifications.map((notification, index) => (
            <Box
              className={`${classes.notification} ${
                notification.status === 'read' && classes.read
              }`}
              key={index}
            >
              <Box className={classes.titleAndDate}>
                <p className={classes.notificationTitle}>
                  {notification.title}
                </p>
                <p className={classes.notificationTitle}>
                  {notification.message}
                </p>

                <p className={classes.notificationDate}>
                  {new Date(notification.createdAt).toLocaleString('en-US', {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                  })}
                </p>
              </Box>
              <MdDeleteOutline className={classes.deleteIcon} />
            </Box>
          ))
        ) : (
          <Text>No New Notification</Text>
        )}
      </Box>
    </Modal>
  );
};

export default Notifications;
